const QUERIES = {
    HAULIER_LIST: 'haulier-list',
    TRAILER_LIST: 'trailer-list',
    REPORT_LIST: 'report-list',
}

export {QUERIES}
